import _ from "lodash";
import { getUniversalHelpers } from "../../helpers";
import { Org, OrgId, OrgSettings } from "@ollie-sports/models";

export async function orgSettings__server__getMultipleOrgSettingsNoAuth(p: { orgIds: OrgId[] }): Promise<OrgSettings[]> {
  const { ollieFirestoreV2: h } = getUniversalHelpers();
  return _.compact(await h.OrgSettings.getDocs(p.orgIds));
}

orgSettings__server__getMultipleOrgSettingsNoAuth.auth = () => {};

// i18n certified - complete
